import { render, staticRenderFns } from "./BookingTerm.vue?vue&type=template&id=c2fa4b1a&scoped=true"
import script from "./BookingTerm.vue?vue&type=script&lang=js"
export * from "./BookingTerm.vue?vue&type=script&lang=js"
import style0 from "./BookingTerm.vue?vue&type=style&index=0&id=c2fa4b1a&prod&lang=css"
import style1 from "./BookingTerm.vue?vue&type=style&index=1&id=c2fa4b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fa4b1a",
  null
  
)

export default component.exports